export default __webpack_public_path__ + "a09cc79615dbc53d35b3d207674d91aa.svg";